<ng-container *ngIf="orderInfo">
    
    <div class="align-center relative">
        
        <div class="main-inner-circle" style="display: none;">
            <div class="status-container step-{{applyStepComplete()}} iconDemo-{{statusCount}}"
                [attr.data-step]="applyStepComplete()">
                <div class="function-listing">
                    <ul>
                        <li *ngFor="let st of status;let i = index" [id]="st.step" [ngStyle]="{
      'transform': circleRotateStyle(i),
      '-webkit-transform': circleRotateStyle(i) }">
                            <div [ngStyle]="{ 'top': '-2px',
        'transform': 'rotate(' + (statusDegree) + 'deg)',
        '-webkit-transform': 'rotate(' + (statusDegree) + 'deg)' }" class="pie">
                                <em [ngStyle]="{
        'transform': 'rotate(' + (-(statusDegree * (st.statusId))) + 'deg)',
        '-webkit-transform': 'rotate(' + (-(statusDegree * (st.statusId))) + 'deg)' }" class="cmn-icn {{st.class}}"
                                    [ngClass]="{'icon-black': isStepCompleted(st)}"></em>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="center-arrow-bg"
                    [ngStyle]="{ '-webkit-transform': arrowPosition(), 'transform': arrowPosition()}"></div>
                <div class="center-arrow-text fade-in" *ngIf="orderInfo.cState">
                    <em class="cmn-icn {{getIconClass(orderInfo.cState.code)}} icon-black"></em>
                    <p class="ng-binding truncate center-text-mw" translate>{{orderInfo.cState.text}} </p>
                </div>
            </div>
        </div>
    </div>
    
    <div class="text-center">
        <div class="data-defination mb-1">
            <ul class="d-flex  justify-content-center my-3">
                <li *ngFor="let st of status;let i = index" [ngClass]="{'selected': isStepCompleted(st) , 'disabledBreadCrumb':orderInfo.isOnHold}">
                    <div class="d-flex flex-column align-items-center">
                        <span class="icons">
                            <em class="tab-icon" [ngClass]="st.iconClass"></em>
                            <em class="fa fa-check-circle iccheck"></em>
                        </span>
                        <span placement="bottom" translate>{{st.Key}}</span>
                        
                    </div>
                </li>
            </ul>
        </div>
    </div>
</ng-container>